import { handleError } from "../error";
import Axios from "axios";

export const requestResetPassword = formData => async dispatch => {
    try {
        return await Axios.post("/password/email", { ...formData });
    }
    catch (error) {
        dispatch(handleError(error));
        return false;
    }
};